var render = function render(){var _vm=this,_c=_vm._self._c;return _c('product-management',{attrs:{"state":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }